import { replica } from '@/shared/sync/replica';
import { tokenStorage } from '@/shared/sync/token-storage';
import { sessionStore } from '../lib/session-store';

/** Revoke the token if the server is reachable, then forget the session and this device's copy. */
export async function signOut(): Promise<void> {
  await replica.http.request('/auth/logout', { method: 'POST', timeoutMs: 5000 }).catch(() => undefined);
  tokenStorage.set(null);
  sessionStore.write(null);
  await replica.wipe();
}
